module.exports = __webpack_public_path__ + "static/media/g-5-a.ae757e0e.jpg";